import React from 'react';
import { useTranslate } from 'react-admin';
import LinearProgress from '@material-ui/core/LinearProgress';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { DocumentItem } from './DocumentItem';

export const DocumentsList = ({
	loading,
	data,
	isOutputDocuments,
	footerContent,
	disabled,
	isCustomerAsTrans,
	permissions,
	record,
	handleDelete,
	handleUpdate,
	resource,
	typeChoices,
}) => {
	const translate = useTranslate();

	return (
		<React.Fragment>
			{loading && !data ? (
				<LinearProgress />
			) : (
				<Grid container spacing={2}>
					{data &&
						data.map(item => (
							<Grid key={item.id} item xs={12} sm={6} md={3}>
								<DocumentItem
									isReadOnly={
										disabled ||
										(isCustomerAsTrans && permissions.company_id !== item.company_id)
									}
									data={{ ...item, relatedEntityId: record.id }}
									handleDelete={handleDelete}
									handleUpdate={handleUpdate}
									isOutputDocuments={isOutputDocuments}
									resource={resource}
									typeChoices={typeChoices}
								/>
							</Grid>
						))}
					{data && data.length === 0 && (
						<Grid item xs={12}>
							<Typography align="center" variant="body2" color="textSecondary">
								{!isOutputDocuments
									? translate('osfc.fields.document.no_documents')
									: translate('osfc.fields.output-document.no_documents')}
							</Typography>
						</Grid>
					)}
					{footerContent && (
						<Grid item xs={12}>
							{footerContent}
						</Grid>
					)}
				</Grid>
			)}
		</React.Fragment>
	);
};
